var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavbarMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4975 0.0664062H0.497489C0.379632 0.0664062 0.283203 0.162835 0.283203 0.280692V1.99498C0.283203 2.11284 0.379632 2.20926 0.497489 2.20926H21.4975C21.6153 2.20926 21.7118 2.11284 21.7118 1.99498V0.280692C21.7118 0.162835 21.6153 0.0664062 21.4975 0.0664062ZM21.4975 16.7807H0.497489C0.379632 16.7807 0.283203 16.8771 0.283203 16.995V18.7093C0.283203 18.8271 0.379632 18.9236 0.497489 18.9236H21.4975C21.6153 18.9236 21.7118 18.8271 21.7118 18.7093V16.995C21.7118 16.8771 21.6153 16.7807 21.4975 16.7807ZM21.4975 8.42355H0.497489C0.379632 8.42355 0.283203 8.51998 0.283203 8.63784V10.3521C0.283203 10.47 0.379632 10.5664 0.497489 10.5664H21.4975C21.6153 10.5664 21.7118 10.47 21.7118 10.3521V8.63784C21.7118 8.51998 21.6153 8.42355 21.4975 8.42355Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMenu);
export default __webpack_public_path__ + "static/media/navbar-menu.eeffbf92d9cdec18774198177a3c7982.svg";
export { ForwardRef as ReactComponent };